import { render, staticRenderFns } from "./DeliveryReportActivity.vue?vue&type=template&id=18c6ce44&"
import script from "./DeliveryReportActivity.vue?vue&type=script&lang=js&"
export * from "./DeliveryReportActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports